
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '__services';

@Injectable({
  providedIn: 'root'
})

export class PaginatorI18nService {

    constructor(private readonly trans: TranslateService) {}

    getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = this.trans.translate('Item per page');
        paginatorIntl.nextPageLabel = this.trans.translate('Next page');
        paginatorIntl.previousPageLabel = this.trans.translate('Previous page');
        paginatorIntl.firstPageLabel = this.trans.translate('First page');
        paginatorIntl.lastPageLabel = this.trans.translate('Last page');
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);
        return paginatorIntl;
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0 || pageSize === 0) {
            return this.trans.translate('of {{length}}', { length });
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return this.trans.translate('{{startIndex}} - {{endIndex}} of {{length}}', { startIndex: startIndex + 1, endIndex, length });
    }
}
